var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"notification__card\">\n    <button class=\"notification__close\" data-code=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"code") : depth0), depth0))
    + "\">\n        <svg>\n            <use xlink:href=\"/images/securitas.spritemap.svg#sprite-close--blue\"></use>\n        </svg>\n    </button>\n    <div class=\"notification__title\">\n        "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"countrySuggestionTitle") : depth0), depth0))
    + "\n    </div>\n    <p class=\"notification__text\">\n        "
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"countrySuggestionText") : depth0), depth0))
    + "\n    </p>\n    <a href=\""
    + alias2(alias1(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"languages") : depth0)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"url") : stack1), depth0))
    + "\" class=\"button button__secondary\">"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"countrySuggestionLinkText") : depth0), depth0))
    + "</a>\n\n</div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),depth0,{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":17,"column":9}}})) != null ? stack1 : "");
},"useData":true});